import { ReactNode, useCallback } from "react";
import { useLocalStorage } from "@rehooks/local-storage";

import useTypedContext from "hooks/useTypedContext";
import { isFedRampRegion } from "utils/region";
import { AccountContext } from "views/AccountWrapper";

import FedRampWarning from ".";
import { FEDRAMP_WARNING_STORAGE_KEY } from "./constants";

const isFedRamp = isFedRampRegion();

type FedRampWarningWrapperProps = {
  children: ReactNode;
};

const FedRampWarningWrapper = ({ children }: FedRampWarningWrapperProps) => {
  const { viewer } = useTypedContext(AccountContext);
  const [acknowledgedValidUntil, setAcknowledgedValidUntil] = useLocalStorage<number>(
    FEDRAMP_WARNING_STORAGE_KEY
  );

  const acknowledged = acknowledgedValidUntil === viewer.validUntil;

  const handleAcknowledge = useCallback(() => {
    setAcknowledgedValidUntil(viewer.validUntil);
  }, [viewer.validUntil, setAcknowledgedValidUntil]);

  if (!isFedRamp) {
    return children;
  }

  if (!acknowledged) {
    return <FedRampWarning onAcknowledge={handleAcknowledge} />;
  }

  return children;
};

export default FedRampWarningWrapper;
